<template>
    <div class="content">
        <TopBar barTheme="white" :barStyle="`background: url(${require('@/assets/images/personal_top_bg.png')}) no-repeat; background-size: 100%;`">
            <span class="page-title" slot="title">收件信息</span>
        </TopBar>
        <div class="receiving-info">
            <div class="pro-box wrap">
                <div class="pic-wrap vc">
                    <img :src="proImg" :alt="product.Name">
                </div>
                <div class="text-wrap">
                    <h3>{{product.Name}}</h3>
                    <p>所需积分：<span class="cur">{{product.Price}}</span></p>
                    <p>数量：<span class="black">1</span></p>
                </div>
            </div>
            <div class="info-box wrap">
                <div class="item-title vc"><i class="icon icon-line"></i>收货信息</div>
                <div class="item-detail">
                    <ul>
                        <li class="vc"><span>收件人</span><input type="text" v-model="userName" disabled></li>
                        <li class="vc"><span>手机号码</span><input type="text" v-model="userTel" disabled></li>
                        <li class="vc"><span>所在地区</span><div><input type="text" v-model="userAdd" disabled></div></li>
                        <li class="vc"><span>详细地址</span><input type="text" v-model="address" disabled></li>
                    </ul>
                </div>
            </div>
            <div class="bot-btn hvc">
                <a class="btn-item btn-close hvc" @click="close" href="javascript: void(0)">关闭</a>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from '@/libs/api.request'
    import TopBar from '@/components/top-bar/'
    export default {
        name: 'shipmentAddress',
        components: {
            TopBar
        },
        data: () => {
            return {
                orderId: null,
                productId: null,
                product: {},
                proImg: '',
                userName: '',
                userTel: '',
                userAdd: '',
                address: ''
            }
        },
        created () {
            let params = this.$route.params
            this.productId = params.productId
            this.userName = params.userName
            this.userTel = params.userTel
            this.userAdd = params.userAdd
            this.address = params.address
        },
        mounted () {
            this.getUserLevelPrivilege(this.productId)
                .then(res => {
                    this.product = res
                    this.proImg = res.Pictures[0]
                })
        },
        methods: {
            close () {
                this.$router.go(-1)
            },
            getUserLevelPrivilege (Id) {
                return new Promise(resolve => {
                    axios.request({
                        url: '/pro/Store/CMProduct/GetDetailById',
                        method: 'get',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        params: {
                            Id,
                            v: (new Date()).getTime()
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .page-title{
        color: #fff;
    }
    .receiving-info{
        padding-top: 1.00rem;
        background-color: #f5f6f8;
        .pro-box{
            display: flex;
            display: -webkit-flex;
            padding-top: 0.30rem;
            padding-bottom: 0.30rem;
            margin-bottom: 0.20rem;
            background-color: #fff;
            .pic-wrap{
                width: 2.25rem;
                height: 1.44rem;
                overflow: hidden;
                img{
                    width: 100%;
                    min-width: 1.44rem;
                }
            }
            .text-wrap{
                padding-left: 0.22rem;
                h3{
                    margin-bottom: 0.10rem;
                    font-weight: bold;
                    line-height: 0.32rem;
                }
                p{
                    color: #747d80;
                    line-height: 0.46rem;
                    .cur{
                        color: #ffa70d;
                    }
                    .black{
                        color: #282b2c;
                    }
                }
            }
        }
        .info-box{
            padding-top: 0.42rem;
            background-color: #fff;
            .item-title{
                padding-bottom: 0.10rem;
                font-size: 0.30rem;
                .icon-line{
                    width: 0.04rem;
                    height: 0.30rem;
                    margin-right: 0.10rem;
                    background-color: #fbc500;
                    border-radius: 0.02rem;
                }
            }
            .item-detail{
                ul{
                    li{
                        height: 1.04rem;
                        border-bottom: #d4dbde solid 0.02rem;
                        span{
                            display: block;
                            width: 1.38rem;
                        }
                        input{
                            width: 5.48rem;
                            height: 0.64rem;
                            &::placeholder{
                                color: #919b9f;
                            }
                            &:disabled{
                                background-color: transparent;
                            }
                        }
                    }
                }
            }
        }
        .bot-btn{
            position: fixed;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1.25rem;
            border-top: #d4dbde solid 0.02rem;
            background-color: #fff;
            .btn-close{
                display: flex;
                display: -webkit-flex;
                width: 6.92rem;
                height: 0.95rem;
                border-radius: 0.07rem;
                background-color: #fbc500;
                font-size: 0.30rem;
            }
        }
    }
</style>
